// extracted by mini-css-extract-plugin
module.exports = {"base":"HeroAreaCarousel-module-base","image":"HeroAreaCarousel-module-image","isActive":"HeroAreaCarousel-module-is-active"};